<template>
  <div class="header">
  <!-- 折叠按钮 -->
    <div class="main-logo" v-if="!isMobile">
      <div class="collapse-btn" @click='switchHandle'>
        <i class="iconfont menu switch" ></i>
      </div>
      <p class="logo">叮叮易建后台管理</p>
    </div>
    <div class="main-logo" v-if="isMobile">
      <div class="collapse-btn" @click='topSideSwitchHandle'>
        <i class="iconfont menu switch" ></i>
      </div>
      <p class="logo">后台管理</p>
    </div>
   
    <div class="header-right" v-if="!isMobile">
      <div class="header-user-con">
        <!-- 用户头像 -->
        <div class="user-avator"><img src="../../assets/img/img.jpg"></div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click">
                    <span class="el-dropdown-link">
                        {{manageLoginData.username}}<i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><span @click="handlePassword">修改密码</span></el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display:block;" @click="logoutDialog">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 退出提示框 -->
      <el-dialog title="退出登录提示" :visible.sync="LognOutVisible" width="300px" center>
        <div class="del-dialog-cnt">确认退出？</div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="LognOutVisible = false">取 消</el-button>
                <el-button type="primary" @click="LognOut" :loading="addLoading">确 定</el-button>
            </span>
      </el-dialog>

      <!--修改密码-->
      <el-dialog title="修改密码" :visible.sync="passwordFormVisible" width="50%" top="5vh">
        <el-form :model="passwordFormData" :rules="passwordFormDataRules" ref="passwordFormData" label-width="100px">

          <el-form-item label="原始密码" prop="oldPassword">
            <el-input type="password" v-model="passwordFormData.oldPassword" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="passwordFormData.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="check_new_password">
            <el-input type="password" v-model="passwordFormData.check_new_password" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="passwordFormVisible = !passwordFormVisible">取消</el-button>
          <el-button type="primary" @click.native="addSubmit('passwordFormData')" :loading="passwordLoading">提交</el-button>
        </div>
      </el-dialog>

    </div>

    <div class="header-right" v-if="isMobile">
      <div class="header-user-con">
        <!-- 用户头像 -->
        
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click">
                    <span class="el-dropdown-link">
                      <img class="avator-min" src="../../assets/img/img.jpg">
                        <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><span @click="handlePassword">修改密码</span></el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display:block;" @click="logoutDialog">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

      <!-- 退出提示框 -->
      <el-dialog title="退出登录提示" :visible.sync="LognOutVisible" width="300px" center>
        <div class="del-dialog-cnt">确认退出？</div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="LognOutVisible = false">取 消</el-button>
                <el-button type="primary" @click="LognOut" :loading="addLoading">确 定</el-button>
            </span>
      </el-dialog>

      <!--修改密码-->
      <el-dialog title="修改密码" :visible.sync="passwordFormVisible" width="50%" top="5vh">
        <el-form :model="passwordFormData" :rules="passwordFormDataRules" ref="passwordFormData" label-width="100px">

          <el-form-item label="原始密码" prop="oldPassword">
            <el-input type="password" v-model="passwordFormData.oldPassword" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="passwordFormData.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="check_new_password">
            <el-input type="password" v-model="passwordFormData.check_new_password" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="passwordFormVisible = !passwordFormVisible">取消</el-button>
          <el-button type="primary" @click.native="addSubmit('passwordFormData')" :loading="passwordLoading">提交</el-button>
        </div>
      </el-dialog>

  </div>
</template>
<script type="text/ecmascript-6">
  import {signout,editPassword} from '@/api/login/login'
  import {isvalidPassword,isvalidUserName } from '@/store/validate';
  import { mapGetters } from 'vuex';
  export default {
    data () {
      let validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        }else  if (!isvalidPassword(value)){
          if (this.passwordFormData.check_new_password !== "") {
            this.$refs.passwordFormData.validateField(
              "check_password"
            );
          }
          callback(new Error('请输入6-20位密码'))
        } else {
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.passwordFormData.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        manageLoginData: {
          username: '',
        },
        // 退出登录
        LognOutVisible: false,
        addLoading: false,
        loading: false,
//      修改密码
        passwordLoading: false,
        passwordFormVisible: false,
        passwordFormData: {
          oldPassword: "",
          password: "",
          check_new_password: ""
        },
        passwordFormDataRules: {
          oldPassword: [
            {
              required: true,
              message: "请输入原始密码",
              trigger: "blur"
            }
          ],
          password: [
            {
              required: true,
              message: "请输入新密码",
              trigger: "blur"
            },
            { validator: validatePass, trigger: "blur" }
          ],
          check_new_password: [
            {
              required: true,
              message: "请再次输入密码",
              trigger: "blur"
            },
            { validator: validatePass2, trigger: "blur" }
          ]
        }
      };
    },
    mounted: function () {
       let userData = JSON.parse(window.localStorage.getItem('manageLogin'));
      this.manageLoginData = {
        username: userData.username
      }
    },
    computed: {
      ...mapGetters(['isCollapse', 'isMobile'])
    },
    methods: {
      switchHandle() {
        this.$store.commit('SET_COLLAPSE');
      },
      topSideSwitchHandle() {
          this.$store.commit('SET_TOP_SIDE_MENU');
      },
      // 显示修改密码界面
      handlePassword(row) {
        this.passwordFormVisible = true;
        this.passwordFormData = {
          oldPassword: "",
          password: "",
          check_new_password: ""
        };
        this.passwordFormData = Object.assign({}, row);
      },

      // 修改密码提交
      async addSubmit(passwordFormData) {
        this.$refs.passwordFormData.validate(async (valid) => {
          if (valid) {
            this.loading = true;
            this.passwordFormVisible = false;
            try {
              const res = await editPassword(this.passwordFormData);
              this.loading = false;
              console.log(this.passwordFormData);
              if (res.code == 10000) {//eslint-disable-line
                this.$message({
                  type: 'success',
                  message: '修改成功'
                });
                if (res.length == 0) {//eslint-disable-line
                  this.$ref[passwordFormData].resetFileds();
                } else {
                  this.$ref[passwordFormData].resetFileds();
                }
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            } catch (err) {
              console.log(err);
            }
          } else {
            this.$notify.error({
              title: '错误',
              message: '请检查输入是否正确',
              offset: 100
            });
            return false;
          }
        });
      },

      // 退出登录页面
      logoutDialog() {
        this.LognOutVisible = true;
      },
      async LognOut() {
        try {
          const res = await signout();
          if (res.code == 10000) {//eslint-disable-line
            this.$message({
              type: 'success',
              message: '退出成功'
            });
            this.$router.push('/login');
            this.loading = false;
            localStorage.removeItem('manageLogin');
          } else {
            throw new Error(res.message);
          }
        } catch (err) {
          this.$message({
            type: 'error',
            message: err.message
          });
          console.log('退出失败');
        }
        this.LognOutVisible = false;
      },
    }
  };
</script>
<style>
  .el-submenu.is-active .el-submenu__title:hover {
    border-left: 3px solid #42b983;
  }
  .el-submenu__title:hover {
    border-left: 3px solid #42b983;
  }
  .el-menu-item:hover {
    border-left: 3px solid #42b983;
  }
</style>
<style scoped>
  .header {
    box-sizing: border-box;
    width: 100%;
    height: 62px;
    font-size: 22px;
    background: #fff;
    color: #333;
  }
  .collapse-btn{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 60px;
  }
  .header .logo{
    float: left;
    line-height: 60px;
    font-size: 22px;
    font-weight: 700;
  }
  .header-right{
    float: right;
    padding-right: 50px;
  }
  .header-user-con{
    display: flex;
    height: 60px;
    align-items: center;
  }
  .user-name{
    margin-left: 10px;
  }
  .user-avator{
    margin-left: 20px;
  }
  .avator-min {
    width: 40px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .user-avator img{
    display: block;
    width:40px;
    height:40px;
    border-radius: 50%;
  }
  .el-dropdown-link{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/Layout/Header.vue